var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
  'pin-input': true,
  'pin-input-error': _vm.error,
  'pin-input-loading': _vm.loading,
}},_vm._l((_vm.length),function(i){return _c('input',{key:i,ref:("input-" + (i - 1)),refInFor:true,attrs:{"data-pin-input":i,"type":_vm.type,"placeholder":_vm.placeholderAt(i - 1),"enterkeyhint":"next"},domProps:{"value":_vm.valueAt(i - 1)},on:{"paste":function($event){$event.preventDefault();return _vm.handlePasteEvent($event)},"keyup":function($event){return _vm.handleKeyEvent(i - 1, $event)}}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }